<template>
  <div class="main-container">
    <div class="form-login">
      <div style="margin-bottom: 10px; display: flex; justify-content: center">
        <img alt="Atosa"
             style="width:80px; height:80px; background-color:white; border-radius: 50vh; padding:3px !important;"
             src="/static/img/logo.png"/>
      </div>
      <div style="text-align: center; padding: 0 10px">
        <strong style="text-transform: uppercase; font-size: 18px; color: #125570;">
          {{ $t('base.sign_up_title') }}
        </strong>
      </div>
      <div style="margin-top: 30px">
        <form @submit="m_login_client">
          <div>
            <p style="font-size: 14px; font-weight: 600; color: #041722; margin-bottom: 5px">
              {{ $t('base.username') }}
            </p>
            <el-input v-model="login_form.form.username" :placeholder="$t('input.username')"></el-input>
          </div>

          <div style="margin-top: 15px">
            <p style="font-size: 14px; font-weight: 600; color: #041722; margin-bottom: 5px">
              {{ $t('base.password') }}
            </p>
            <el-input v-model="login_form.form.password" :placeholder="$t('input.password')" type="password"
                      show-password="">
            </el-input>
          </div>
          <div style="margin-top: 10px" class="text-right">
            <a href="javascript:void(0)" @click="$router.push('/forgot-password')">
              <strong style="font-size: 14px">{{ $t('base.forgot_password') }}?</strong>
            </a>
          </div>

          <div style="margin-top: 25px">
            <el-button type="summit" class="full-w" :loading="login_form.loading"
                       @click="m_login_client">
              {{ $t('base.login') }}
            </el-button>
          </div>

          <div style="margin-top: 35px; text-align: center">
            <strong style="font-size: 14px">{{ $t('base.existed_account') }}? </strong>
            <a href="javascript:void(0)" @click="$router.push('/register')">
              <strong style="font-size: 14px" class="text-primary">{{ $t('base.register_now') }}</strong>
            </a>
          </div>

          <button type="submit" style="display: none;"/>
        </form>
      </div>
    </div>

    <div class="info-container">
      <div>
        <strong>{{ $t('base.join_shopee_ads_course') }} </strong>
        <a href="https://www.quangcaoshopee.com" target="_blank" class="text-primary">{{ $t('base.here') }}</a>
      </div>
      <div>
        <strong> {{ $t('base.learn_about_atosa') }}</strong>
        <a href="https://atosa.asia" target="_blank" class="text-primary">{{ $t('base.here') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login-page',

  data() {
    return {
      login_form: {
        loading: false,
        form: {
          username: '',
          password: ''
        }
      }
    }
  },

  beforeCreate() {
    if (typeof this.$store.state.userInfo.username !== 'undefined') this.$router.push('/')
  },

  methods: {
    m_login_client(e) {
      try {
        e.preventDefault()
      } catch (e) {
      }

      this.login_form.loading = true
      this.$http.post(this.API.store_account__login, {
        ...this.login_form.form,
        version_no: 'atosa_web'
      }, {})
        .then(async (res) => {
          this.login_form.loading = false
          const data = res.body.data
          await this.$store.dispatch('set__user_info', data)
          localStorage.setItem('session', JSON.stringify(data))

          const resp = await this.$http.get(this.API.store_get_current_package, this.cf())
          await this.$store.dispatch('set__package', resp.body.data)
          localStorage.setItem('pack', JSON.stringify(resp.body.data))

          this.EB.$emit('get_advanced_ads_list')
          this.ntf_s(this.$t('base.login_success'))

          if (this.$route.query.r) {
            this.$router.push(this.$route.query.r)
          } else {
            this.$router.push('/shop')
          }
        })
        .catch(error => {
          this.login_form.loading = false
          this.ntf_w(error)
        })
    }
  }
}
</script>

<style lang="scss">
.main-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url("/static/img/Group 483x3.png");
  //background-position-x: -10px;
  background-position-y: -60px;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.form-login {
  width: 430px;
  position: absolute;
  top: 10%;
  //top: 50%;
  //transform: translate(0, -50%);
  //right: 130px;
  right: 8%;
  padding: 20px 30px;
  margin: auto;
  background: #FFFFFF;
  box-shadow: 0 2px 22px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 999;
}

.info-container {
  width: 100%;
  position: absolute;
  bottom: 0;
  text-align: center;
  padding: 0 0 15px;

  div strong {
    font-size: 13px;
    color: #041722;
    line-height: 30px;
  }

  div a {
    font-size: 13px;
    line-height: 30px;
    font-weight: bold;
  }
}

@media screen and (min-width: 1600px) {
  .form-login {
    top: 18%;
    right: 13%;
  }
}

@media screen and (min-width: 1900px) {
  .form-login {
    top: 18%;
    right: 13%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sign/login.vue